export default __webpack_public_path__ + "static/media/regulatory--end-of-no-overtaking--g4.11329ed0.png";